import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
import { Button } from '@gisatcz/ptr-atoms';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MapWrapper = function MapWrapper(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? false : _ref$title,
    active = _ref.active,
    onMapRemove = _ref.onMapRemove,
    stateMapKey = _ref.stateMapKey,
    mapKey = _ref.mapKey,
    name = _ref.name,
    children = _ref.children;
  var renderTitle = function renderTitle() {
    if (title === true) {
      title = name || mapKey || stateMapKey || 'Map';
    }
    return /*#__PURE__*/_jsx("div", {
      className: "ptr-map-wrapper-title",
      title: title,
      children: title
    });
  };
  var renderCloseButton = function renderCloseButton() {
    var wrapperMapKey = stateMapKey || mapKey;
    return /*#__PURE__*/_jsx("div", {
      className: "ptr-map-wrapper-close-button",
      children: /*#__PURE__*/_jsx(Button, {
        icon: "times",
        inverted: true,
        invisible: true,
        onClick: function onClick() {
          return onMapRemove(wrapperMapKey);
        }
      })
    });
  };
  var wrapperClasses = classNames('ptr-map-wrapper', {
    active: active
  });
  return /*#__PURE__*/_jsxs("div", {
    className: wrapperClasses,
    children: [/*#__PURE__*/_jsxs("div", {
      className: "ptr-map-wrapper-header",
      children: [onMapRemove ? renderCloseButton() : null, title ? renderTitle() : null]
    }), children]
  });
};
MapWrapper.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  mapKey: PropTypes.string,
  name: PropTypes.string,
  onMapRemove: PropTypes.func,
  stateMapKey: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
};
export default MapWrapper;